import React from "react";
import { BiCaretDown, BiCaretUp } from "react-icons/bi";

/**
 * SEO-Optimized Navigation Title Component
 * Displays a section or category title with optional toggle icons.
 * Suitable for sidebar filters, product categories, or trade sections.
 */
const NavTitle = ({ title, icons = false, showicon = true }) => {
  return (
    <header
      className="flex items-center justify-between pb-5"
      aria-label={`Section Title: ${title}`}
    >
      {/* Section Title */}
      <h3 className="font-bold lg:text-xl text-primeColor">
        {title} - Explore Top Quality Products
      </h3>

      {/* Optional Expand/Collapse Icon for Categories or Filters */}
      {icons && (
        <span
          className="text-lg text-gray-700 cursor-pointer"
          aria-label={showicon ? "Expand section" : "Collapse section"}
        >
          {showicon ? <BiCaretDown /> : <BiCaretUp />}
        </span>
      )}
    </header>
  );
};

export default NavTitle;
